import { render, staticRenderFns } from "./PersonnelRecordDetailsTabEmergencyContacts.vue?vue&type=template&id=1ddb1e53"
import script from "./PersonnelRecordDetailsTabEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabEmergencyContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports